// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"37bb1a23","95":"38bfd890","147":"37bb1a23","288":"43beac59","308":"38bfd890","791":"37bb1a23","958":"3c75485b"}[chunkId] + ".chunk.css";
};